import { useEffect } from 'react';

import { useAddBrandCategoryToLocalStorage } from '@/modules/product/hooks/useAddBrandCategoryToLocalStorage';
import { useAddIsPLARefererToSessionStorage } from '@/modules/product/hooks/useAddIsPLARefererToSessionStorage';
import { useAddRecentlyViewedToLocalStorage } from '@/modules/product/hooks/useAddRecentlyViewedToLocalStorage';

export function useProductView() {
  useEffect(() => {
    // Adding a slight delay with setTimeout to ensure `window.scrollTo` works reliably in Chrome mobile.
    // Reference: https://stackoverflow.com/questions/15691569/javascript-issue-with-scrollto-in-chrome/15694294#15694294
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  useAddBrandCategoryToLocalStorage();
  useAddRecentlyViewedToLocalStorage();
  useAddIsPLARefererToSessionStorage();
}
